export default "__VITE_ASSET__BFunyf2K__"